(function () {
    'use strict';

    run.parts.warnBeforeLeaving = function () {
        let content_changed = false;
        let submitted = false;

        // Confirm exit if content changed
        window.onbeforeunload = function () {
            if (window.content_changed == true && !submitted) {
                return translations.changesUnsavedWarning;
            }
        }

        $("form").submit(function() {
            submitted = true;
        });


        $(document).on('change input', 'input, select, textarea', function (e) {
            window.content_changed = true;
        });
    };
})();